"use client";
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAmplitudeContext = exports.AmplitudeContextProvider = exports.AmplitudeContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const amplitude_1 = require("./amplitude");
exports.AmplitudeContext = (0, react_1.createContext)(undefined);
const AmplitudeContextProvider = ({ amplitudeOptions, children, }) => {
    const [amplitudeClient, setAmplitudeClient] = (0, react_1.useState)(new amplitude_1.AmplitudeBrowserClient(amplitudeOptions));
    (0, react_1.useEffect)(() => {
        setAmplitudeClient(new amplitude_1.AmplitudeBrowserClient(amplitudeOptions));
        // Reset common plugin on render to ensure nested contexts don't interfere with each other
        amplitudeClient.resetPlugins();
    }, [amplitudeOptions]);
    return ((0, jsx_runtime_1.jsx)(exports.AmplitudeContext.Provider, { value: amplitudeClient, children: children }));
};
exports.AmplitudeContextProvider = AmplitudeContextProvider;
const useAmplitudeContext = () => {
    const context = (0, react_1.useContext)(exports.AmplitudeContext);
    if (context === undefined) {
        throw new Error("useAmplitudeContext must be used within a AmplitudeContextProvider");
    }
    return context;
};
exports.useAmplitudeContext = useAmplitudeContext;
